import { FC } from 'react';

import { PrismicNextLink } from '@prismicio/next';

import {
  ImageWithTextSideBySideSlice,
  ImageWithTextSideBySideSliceWithSocialIcons,
} from '@/types';

import style from './withsocialiconsvariation.module.scss';
import {
  DefaultComponentSection,
  textAlign,
} from '../ImageWithTextSideBySide.components';
import { useFilteredSliceItemsByLocationSlug } from '@/hooks';
import { PrismicImageWithAlt } from '@/components/PrismicImageWithAlt';
import { resolveIconSizeToken } from '../../../theme/tokens';

export const WithSocialIconsVariation: FC<{
  slice: ImageWithTextSideBySideSliceWithSocialIcons &
    ImageWithTextSideBySideSlice;
}> = ({ slice }) => {
  const { filteredItems } = useFilteredSliceItemsByLocationSlug(slice?.items);
  const iconSizeClass = resolveIconSizeToken(
    slice.primary.social_image_size as string | null,
  );

  return (
    <DefaultComponentSection slice={slice}>
      {filteredItems?.length > 0 && (
        <div
          className={`${style.items_section} ${iconSizeClass}`}
          style={{
            justifyContent: textAlign(
              slice.primary.content_horizontal_align as string,
            ),
          }}
        >
          {filteredItems?.map((item, index) => (
            <div className={style.item} key={index}>
              {item.social_image.url && (
                <PrismicNextLink
                  aria-label={`Go to ${item.social_image.url} in a new tab`}
                  field={item.link}
                >
                  <figure className={style.image}>
                    <PrismicImageWithAlt
                      defaultAlt="Social icon"
                      field={item.social_image}
                    />
                  </figure>
                </PrismicNextLink>
              )}
            </div>
          ))}
        </div>
      )}
    </DefaultComponentSection>
  );
};
